import { JuloUpdateEntry } from "./types"

export const foretagEntry: JuloUpdateEntry = {
  slug: "2026-05-06-foretag",
  date: "2026-05-06",
  title: "Tagga jobb med företag och skapa fakturaunderlag",
  description:
    "Nu kan ni lägga upp företag under [Inställningar → Företag](/settings/companies), med avdelningar, kontaktpersoner och valfri prislista. När ni bokar ett nytt jobb kan ni tagga det med ett företag direkt i bokningsformuläret. På ett befintligt jobb gör ni det genom att klicka på pennan i ”Kunduppgifter”-kortet och byta till fliken ”Företag”, där ni väljer företag, avdelning och referens. På översikten finns nu en Företagsjobb-vy där ni kan filtrera på status och fakturering, och bulk-ladda ner ett fakturaunderlag (PDF) för flera jobb samtidigt.",
  images: [
    {
      src: "/julo-updates/2026-05-06-foretag/nytt-foretag.png",
      alt: "Modal för att skapa ett nytt företag med fält för namn, telefonnummer, e-post, organisationsnummer, prislista, avdelningar och kontaktpersoner.",
    },
    {
      src: "/julo-updates/2026-05-06-foretag/foretagsjobb-oversikt.png",
      alt: "Företagsjobb-vyn på översikten med val av företag, faktureringsfilter (Alla, Ofakturerad, Fakturerat), statusfilter och en lista med jobb kopplade till företaget.",
    },
    {
      src: "/julo-updates/2026-05-06-foretag/fakturaunderlag.png",
      alt: "Exempel på ett fakturaunderlag (PDF) med företagsuppgifter, servicedatum, kund, cykel, referens, åtgärder och kostnader uppdelat på arbete och produkter.",
    },
  ],
}
